<div class="plan-container">
    <h2 class="subdetails-title">Subscription Details</h2>
    <div class="subdetails-content">
        <div class="name-section">
            <h3>Boomi Balagan</h3>
            <p style="color: #7c7c7c;">boomibalagan@gmail.com</p>
        </div>
        

            <div class="detail-row">
                <span class="label">Subscription Start Date:</span>
                <span class="value">January 1, 2023</span>
            </div>
            <div class="divider"></div>
            <div class="detail-row">
                <span class="label">Subscription End Date:</span>
                <span class="value">December 31, 2023</span>
            </div>        
          <button class="btn btn-primary btn-sm upgrade" (click)="onUpgrade()">Upgrade to Pro </button>  
    </div>
</div>
